/*
 *  TTTech nerve-ui-components
 *  Copyright(c) 2021. TTTech Industrial Automation AG.
 *
 *  ALL RIGHTS RESERVED.
 *
 *  Usage of this software, including source code, netlists, documentation,
 *  is subject to restrictions and conditions of the applicable license
 *  agreement with TTTech Industrial Automation AG or its affiliates.
 *
 *  All trademarks used are the property of their respective owners.
 *
 *  TTTech Industrial Automation AG and its affiliates do not assume any liability
 *  arising out of the application or use of any product described or shown
 *  herein. TTTech Industrial Automation AG and its affiliates reserve the right to
 *  make changes, at any time, in order to improve reliability, function or
 *  design.
 *
 *  Contact Information:
 *  support@tttech-industrial.com
 *
 *  TTTech Industrial Automation AG, Schoenbrunnerstrasse 7, 1040 Vienna, Austria
 *
 */
import LIST_OF_TIMEZONES from './listOfTimezones.json';

/**
 * @property {Object} VALIDATION_REGEX
 *
 * */

const VALIDATION_REGEX = {
  STRING_CONTAINS_ONLY_SPACES: /^\s*$/,
  // eslint-disable-next-line no-control-regex
  NO_CONTROL_CHARACTERS: /^[^\u0000-\u001f\u007f-\u009f]*$/,
};

export { VALIDATION_REGEX, LIST_OF_TIMEZONES };

export const STATUSES = {
  IN_PROGRESS: 'IN_PROGRESS',
  FAILED: 'FAILED',
  COMPLETED: 'COMPLETED',
  ABORTED: 'ABORTED',
  STOPPING: 'STOPPING',
  ERROR: 'ERROR',
  FAIL: 'FAIL',
  SUCCESS: 'SUCCESS',
  CREATED: 'CREATED',
  REJECTED: 'REJECTED',
  INPROGRESS: 'IN PROGRESS',
};
